<template>
  <section class="container section pt-5">
    <link-order v-if="ready" />
  </section>
</template>

<script>
import { get, post, error_message, format_currency } from "@/utils";
import LinkOrder from "./link_order/Index.vue";

export default {
  name: "BakeryOnlineOrder",
  components: { LinkOrder },
  computed: {},
  data() {
    return {
      ready: false,
    };
  },
  methods: {},
  mounted() {},
  created() {
    let v = this;

    v.$root.loader(true);
    get("/system/settings", {})
      .then((r) => {
        localStorage.setItem("system_settings", JSON.stringify(r));
        if (r && r.free_use_urls)
          localStorage.setItem("permissions", JSON.stringify(r.free_use_urls));
        v.ready = true;
      })
      .catch((err) => {
        console.error(err);
        error_message(err);
      })
      .finally(() => {
        v.$root.loader(false);
      });
  },
};
</script>

<style scoped></style>
